import { PdTrashItem } from "./PdTrashItem.js";
//#region src/pd-trash/pd-trash-item.ts
var tag = "pd-trash-item";
if (!customElements.get(tag)) customElements.define(tag, PdTrashItem);
//#endregion
export { PdTrashItem };
